import BaseAPIService from "./BaseApiService";

function getPaymentsByPhone(phone) {
  return BaseAPIService.get(`/api/v1/payments/${phone}`);
}

function getPayments() {
  return BaseAPIService.get(`/api/v1/payments`);
}

function checkout({ phone, amount, planName,priceId }) {
  let payload = {
    phone: phone,
    amount: amount,
    plan: planName,
    price_id:priceId
  }
  return BaseAPIService.post(
    `/api/v1/payments/checkout`,
    null,
    payload
  );
}

function getUpdatedStatus(phone,sessionId,type) {
  return BaseAPIService.get(`/api/v1/payments/session/${phone}/${type}/${sessionId}`);
}

function unsubscribe(payload) {
  return BaseAPIService.post(`/api/v1/payments/subscription/cancel`,null,payload);
}

export const PaymentAPIService = {
  checkout,
  getPayments,
  getPaymentsByPhone,
  getUpdatedStatus,
  unsubscribe
};